import { translate } from '../../../Services/translation';
import { string, object, boolean, mixed } from 'yup';

const requiredTranslation = translate('validation.required');

export const alwaysRequiredSchema = object().shape({
  acceptTermsOfCondition: boolean()
    .required(translate('validation.checkrequired'))
    .oneOf([true]),
  selectedDeliveryMethod: object().required(requiredTranslation),
  selectedPaymentMethod: object().required(requiredTranslation),
});

export const privateCustomerAddressSchema = object().shape({
  lastName: string().nullable().required(requiredTranslation),
  firstName: string().nullable().required(requiredTranslation),
  address: string().nullable().required(requiredTranslation),
  zipCode: string().nullable().required(requiredTranslation),
  city: string().nullable().required(requiredTranslation),
  country: mixed()
    .nullable()
    .required(requiredTranslation)
    .notOneOf([''], requiredTranslation),
  phoneNumber: string().nullable().required(requiredTranslation),
  email: string()
    .nullable()
    .required(requiredTranslation)
    .email(translate(`validation.email`)),
});

export const privateCustomerAlternativeAddressSchema = object().shape({
  city: string().nullable().required(requiredTranslation),
  zipCode: string().nullable().required(requiredTranslation),
  address: string().nullable().required(requiredTranslation),
  lastName: string().nullable().required(requiredTranslation),
  firstName: string().nullable().required(requiredTranslation),
});

export const businessCustomerDetailsSchema = object().shape({
  email: string()
    .required(requiredTranslation)
    .nullable()
    .email(translate('validation.email')),
  selectedDeliveryAddressId: string().nullable().required(requiredTranslation),
  selectedBillingAddressId: string().nullable().required(requiredTranslation),
});
